import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import moment from "moment";

export default class extends Controller {
  connect() {
    console.log('initTrainingsForm');
    $('#training_times').on('cocoon:after-insert', function (e, image) {
      $(image).css('display', 'block');
      $(image).fadeIn('slow', function () {
        attachListeners();
      });
    }).on('cocoon:before-remove', function (e, image) {
      $(this).data('remove-timeout', 1000);
      image.hide('slow');
    });

    $('.nested-fields').each(function () {
      attachListeners();
    });

    function attachListeners() {
      $('.datetimepicker').datetimepicker({
        // put here your custom picker options, that should be applied for all pickers
        showClear: true,
        //focusOnShow: false
      });
      $('.training_training_times_start_at').find('.datetimepicker').datetimepicker().on('dp.change', function (e: any) {
        console.log('changed!');
        if (e.date == null)
          return;
        const finish_at = $(this).closest('li').find('.training_training_times_finish_at')
          .find('.datetimepicker').datetimepicker().data("DateTimePicker");
        if (finish_at.date() == null) {
          finish_at.date(e.date);
        } else if (e.oldDate != null) {
          finish_at.date(e.date.add(moment.duration(finish_at.date() - e.oldDate)));
        }
        $('#training_check_in_deadline').parent().datetimepicker().data("DateTimePicker")
          .date(e.date.subtract(3, 'days').hour(22).minute(30));
      });
    }

  }
}